export const CREDIT_CARD_IDS = [901, 1500]
export const OTHER_PAYMENTS = [901]
